import React, { useState } from "react";
import { customFieldMetadataItem } from "../../redux/customFields/customFieldsSlice";
import { useAppSelector } from "../../redux/hooks";
import { Dropdown, Table } from "react-bootstrap";
import ItemListingTitle from "../../components/itemListingTitle/itemListingTitle";
import { ReactSVG } from "react-svg";
import threedotvertical from "../../assets/images/three-dots-vertical.svg";
import editicon from "../../assets/images/edit-icon.svg";
import viewicon from "../../assets/images/view-icon.svg";
import deactivateicon from "../../assets/images/deactivate-icon.svg";
import deleteicon from "../../assets/images/delete-icon.svg";
import duplicateicon from "../../assets/images/duplicate-icon.svg";

const CustomFieldsManagement = () => {
    const defaultCustomFields = useAppSelector(customFieldMetadataItem);
    const [customFieldList, setCustomFieldList] = React.useState<any>(defaultCustomFields);
    const defaultFilter = { searchText: "", active: true };
    const [searchFieldVal, setSearchFieldVal] = useState(defaultFilter);
    console.log("customFieldList", customFieldList);
    return (
       <div className="user-listing-wrapper">
             <ItemListingTitle
                title="Custom Fields Master"
                buttonTitle="Add New"
                href="/create-custom-fields"
                disRecords={customFieldList.length || 0}
                totalRecords={customFieldList.length || 0}
                searchVal={searchFieldVal}
                setSearchVal={setSearchFieldVal}
                defaultFilter={defaultFilter}
                isAddPermitted={true}
            />
             <div className="listing-table-wrapper">
               {/* {getUsersListLoading ||
               setUserStatusActiveLoading ||
               setUserStatusDeActiveLoading ||
               deleteUserLoading ||
               exportUserLoading ||
               importUserLoading ? (
                 <Loading />
               ) : null} */}
               <Table responsive="md" hover={true}>
                 <thead>
                   <tr>
                     {/* <th>SRX ID</th> */}
                     <th>Name</th>
                     <th>Control Type</th>
                     <th>Data Type</th>
                     <th>Defult Value</th>
                     <th>Module</th>
                     <th>Is Required</th>
                     <th>Is Active</th>
                     <th></th>
                   </tr>
                 </thead>
                 <tbody>
                   {customFieldList?.map((x: any) => (
                     <tr
                       key={x?.id}
                     >
                       <td>{x?.name}</td>
                       <td>{x?.controlType?.name}</td>
                       <td>{x?.datatype?.name}</td>
                       <td>{x?.defaultValue ?? "-"}</td>
                       <td>{x?.customFieldModule?.name}</td>
                       <td>
                         {x?.isRequired ? "Yes" : "No"}
                       </td>
                       <td>
                         <span
                            className={`status-circle ${x?.isActive ? "active" : "inactive"}`}
                        >
                        {x?.isActive ? "Active" : "Inactive"}
                        </span>
                       </td>
                       <td>
                         <Dropdown>
                           <Dropdown.Toggle variant="link" id="dropdown-basic">
                             <ReactSVG
                               className="svg-box"
                               wrapper="span"
                               src={threedotvertical}
                             />
                           </Dropdown.Toggle>
                           <Dropdown.Menu>
                             <Dropdown.Item
                            //    onClick={() => {
                            //      viewUser(x);
                            //    }}
                             >
                               <ReactSVG
                                 className="svg-box"
                                 wrapper="span"
                                 src={viewicon}
                               />
                               View
                             </Dropdown.Item>
                             <Dropdown.Item
                            //    onClick={() => {
                            //      updateStatus(x);
                            //    }}
                            //    style={
                            //      loginUserId === x.id
                            //        ? {
                            //            pointerEvents: "none",
                            //            opacity: 0.5,
                            //          }
                            //        : {}
                            //    }
                             >
                               <ReactSVG
                                 className="svg-box"
                                 wrapper="span"
                                 src={deactivateicon}
                               />
                               {x.isActive ? "Deactivate" : "Activate"}
                             </Dropdown.Item>
                             <Dropdown.Item
                            //    onClick={() => {
                            //      editUser(x);
                            //    }}
                             >
                               <ReactSVG
                                 className="svg-box"
                                 wrapper="span"
                                 src={editicon}
                               />
                               Edit
                             </Dropdown.Item>
                             <Dropdown.Item
                            //    onClick={() => {
                            //      setCurrentUser(x);
                            //      toggleDuplicateModal();
                            //    }}
                            //    style={
                            //      loginUserId === x.id
                            //        ? {
                            //            pointerEvents: "none",
                            //            opacity: 0.5,
                            //          }
                            //        : {}
                            //    }
                             >
                               <ReactSVG
                                 className="svg-box"
                                 wrapper="span"
                                 src={duplicateicon}
                               />
                               Duplicate
                             </Dropdown.Item>
                             <Dropdown.Item
                            //    onClick={() => {
                            //      setCurrentUser(x);
                            //      toggleModal(x);
                            //    }}
                            //    style={
                            //      loginUserId === x.id
                            //        ? {
                            //            pointerEvents: "none",
                            //            opacity: 0.5,
                            //          }
                            //        : {}
                            //    }
                             >
                               <ReactSVG
                                 className="svg-box"
                                 wrapper="span"
                                 src={deleteicon}
                               />
                               Delete
                             </Dropdown.Item>
                           </Dropdown.Menu>
                         </Dropdown>    
                       </td>
                     </tr>
                   ))}
                 </tbody>
               </Table>
             </div>
             {/* <DeleteConfModel
               showModal={showModal}
               toggleModal={onClose}
               deleteAction={deleteUser}
               modelName={`User`}
               recordName={currentUser?.email || ""}
             /> */}
             {/* <DublicateUserModel
               selectedUser = {currentUser}
               showModal = {showDuplicateModal}
               toggleDuplicateModal = {toggleDuplicateModal}
               reloadListing = {fetchUserList}
               userList ={usersList}
             /> */}
           </div>
    );
}
export default CustomFieldsManagement;

